/* eslint-disable */
import { useEffect, useState } from "react";
import { X } from "lucide-react";
import StarRating from "./StarRating";
import { directoryApi } from "./api";
import useModalA11y from "../utils/useModalA11y";
import "./ReviewModal.css";

export default function ReviewModal({
  open,
  existing,
  contactId,
  contactName,
  onClose,
  onSaved,
}) {
  const modalRef = useModalA11y({ isOpen: open, onClose });
  const [rating, setRating] = useState(0);
  const [content, setContent] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setRating(existing?.rating || 0);
      setContent(existing?.content || "");
      setError("");
    }
  }, [open, existing]);

  if (!open) return null;

  const submit = async (e) => {
    e?.preventDefault();
    if (rating < 1) {
      setError("Please pick a star rating");
      return;
    }
    setBusy(true);
    setError("");
    try {
      await directoryApi.upsertReview(contactId, {
        rating,
        content: content.trim() || null,
      });
      onSaved && onSaved();
    } catch (err) {
      setError(err.message || "Could not save review");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="vsd-rm-overlay" onClick={onClose}>
      <form
        ref={modalRef}
        className="vsd-rm-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
        role="dialog"
        aria-modal="true"
        aria-labelledby="vsd-rm-title"
      >
        <div className="vsd-rm-head">
          <h2 id="vsd-rm-title">
            {existing ? "Edit your review" : "Write a review"}
          </h2>
          <button
            type="button"
            className="vsd-rm-close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <p className="vsd-rm-sub">
          How was your experience with{" "}
          <strong>{contactName}</strong>?
        </p>

        <div className="vsd-rm-field">
          <label>Your rating</label>
          <div className="vsd-rm-stars">
            <StarRating value={rating} onChange={setRating} size={36} />
          </div>
        </div>

        <div className="vsd-rm-field">
          <label htmlFor="review-content">Your review (optional)</label>
          <textarea
            id="review-content"
            rows={4}
            placeholder="What worked well? What could be better?"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            maxLength={2000}
          />
          <span className="vsd-rm-counter">{content.length} / 2000</span>
        </div>

        {error && <div className="vsd-rm-error">{error}</div>}

        <div className="vsd-rm-actions">
          <button
            type="button"
            className="vsd-rm-btn-secondary"
            onClick={onClose}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="vsd-rm-btn-primary"
            disabled={busy || rating < 1}
          >
            {busy
              ? "Saving…"
              : existing
              ? "Update review"
              : "Submit review"}
          </button>
        </div>
      </form>
    </div>
  );
}
